import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import CaretDownRaw from '../../../../../svg/caret-down.svg'
export const CaretDown = styled(CaretDownRaw)`
  height: 7px;
  width: 14px;
  path {
    stroke: ${(props) => props.theme.colors.default};
  }
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`
export const Link = styled.div`
  margin: 0;
  display: block;
  padding: 0 36px;
  background: #fff;
  color: #666666;
  text-decoration: none;
  &:hover {
    color: #000;
    cursor: pointer;
  }
  position: relative;
  text-decoration: none;
  transition: color 0.1s, background-color 0.1s;
  &:first-child {
    padding-left: 0;
  }
  ${(props) =>
    props.active &&
    `::after {
      position: absolute;
      content: '';
      background-color: #333;
      height: 1px;
      bottom: -10px;
      left: 0;
      right: 0;
      margin-right: 36px;
      z-index: 1;
      border-bottom: 1px solid #333;
    }
  `}
  @media (max-width: 1024px) {
    ${(props) =>
      props.active &&
      `::after {
      bottom: -9px;
    }
  `}
  }
`
export const NavTabTitle = styled.li`
  text-align: center;
  font-size: 22px;
  color: #333333;
  margin: 0px;
`
export const DropDownMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 1024px) {
    display: none;
  }
  [data-type='tabs-more-container'] {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`
export const Inner = styled.div`
  position: relative;
`
export const VisibleMenu = styled.ul`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  height: 35px;
  width: 100%;
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
  @media (max-width: 1024px) {
    overflow-x: scroll;
    flex-wrap: nowrap;
    white-space: nowrap;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  padding-bottom: 8px;
  @media (min-width: 1024px) {
    li {
      height: 30px;
    }
  }
`
export const NavBar = styled(Row)`
  margin-top: 64px;
  position: relative;
  margin-bottom: 4px;
  [data-type='line'] {
    position: absolute;
    width: 100%;
    height: 2px;
    background: #eee;
    bottom: 0px;
    left: 0;
  }
  [data-type='active'] {
    display: block;
  }
`
export const HiddenMenu = styled.ul`
  display: none;
  white-space: nowrap;
  position: absolute;
  background-color: #fff;
  width: 250px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  z-index: 1;
  list-style: none;
  padding: 0;
  margin-top: 35px;
  li {
    float: none;
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    text-align: left;
    background-color: transparent;
  }
  a::after {
    margin-right: 0px;
  }
`
export const DropDownButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  height: 34px;
  background-color: transparent;
  text-align: center;
  font-size: 22px;
  color: #666666;
  margin: 0px;
  padding-bottom: 8px;
  span {
    padding-right: 8px;
  }
  &:hover {
    color: #000;
    cursor: pointer;
  }
`